export const REPORT_DRAFT_STORAGE_KEY = "soccertycs:match-report:draft";

const getSessionStorage = () =>
  typeof window !== "undefined" ? window.sessionStorage : null;

export const getMatchDraftKey = (match) =>
  match ? String(match.id ?? match.idPartido ?? match.codacta ?? match.codActa ?? "") : "";

export const readReportDraft = (storage = getSessionStorage()) => {
  if (!storage) return null;
  try {
    return JSON.parse(storage.getItem(REPORT_DRAFT_STORAGE_KEY) || "null");
  } catch {
    return null;
  }
};

export const writeReportDraft = (draft, storage = getSessionStorage()) => {
  if (!storage) return false;
  try {
    storage.setItem(REPORT_DRAFT_STORAGE_KEY, JSON.stringify(draft));
    return true;
  } catch {
    return false;
  }
};
